<template>
  <v-app>
    <v-toolbar app>
      <v-avatar><v-img src="/img/logo_simple.png"></v-img></v-avatar>
      <v-toolbar-title>Acocasa</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>
